"use client";

import { useState, useCallback } from "react";
import YoutubeEmbed from "../youtube-embed";

interface YoutubeSetItemProps {
  videoId: string;
  title: string;
  artistName: string;
  index: number;
}

export default function YoutubeSetItem({
  videoId,
  title,
  artistName,
  index,
}: YoutubeSetItemProps) {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayingChange = useCallback((playing: boolean) => {
    setIsPlaying(playing);
  }, []);

  return (
    <div
      className="relative group rounded-md overflow-hidden"
      key={`YoutubeSet-${artistName}-${index}`}
    >
      {!isPlaying && (
        <>
          <div
            className="z-40 absolute top-0 bg-gradient-to-t from-transparent via-transparent to-theme-dark-background w-full h-full opacity-40
            pointer-events-none transition-opacity duration-200 group-hover:opacity-20"
          />
          <p className="z-50 absolute top-3 left-3 right-2 text-ink text-sm transition-opacity duration-200 group-hover:opacity-0">
            {title}
          </p>
        </>
      )}
      <YoutubeEmbed
        key={`YoutubeSet-${artistName}-${index}`}
        id={videoId}
        title={title}
        onPlayingChange={handlePlayingChange}
      />
    </div>
  );
}
